import "./assets/Styles/style.css";
import "./assets/Styles/table.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.min.css";
import "react-modern-drawer/dist/index.css";
import "font-awesome/css/font-awesome.min.css";
import "react-quill/dist/quill.snow.css";
import React, { Suspense, lazy, useEffect, useRef } from "react";
import { Route, BrowserRouter, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import BeforeLoginRoute from "./Helper/BeforeLoginRoute";
import ProtectedRouter from "./Helper/ProtectedRoute";
import { Loader } from "./Component/Loader";
import MyProfile from "./pages/MyProfile";

import UploadedVideo from "./pages/UploadedVideo";
import ScheduledVideos from "./pages/ScheduledVideos";
import UploadVideo from "./pages/UploadVideo";
import { useDispatch, useSelector } from "react-redux";
import { apiUrl, BaseURL, endpointsUrl } from "./config/apiUrl";
import { Get } from "./Axios/AxiosFunctions";
import {
  saveNotiData,
  setAllChannels,
  setAllVideos,
} from "./store/common/commonSlice";
import AddVideoGallery from "./pages/AddVideoGallery";
import VideoDetails from "./pages/VideoDetails";
import TermsAndCondition from "./pages/TermsAndCondition";
import TermsAndConditionView from "./pages/TermsAndConditionView";
import PrivacyPolicyView from "./pages/PrivacyPolicyView";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import NotificationsPage from "./pages/NotificationsPage/NotificationsPage";
import { io } from "socket.io-client";

const Login = lazy(() => import("./pages/Login"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const TemaMember = lazy(() => import("./pages/TeamMember"));
const Channels = lazy(() => import("./pages/Channels"));

const CalendarPage = lazy(() => import("./pages/Calendar"));
const AllVideos = lazy(() => import("./pages/AllVideos"));

const NotFound = lazy(() => import("./pages/NotFound"));

function App() {
  const socket = useRef(null);
  const dispatch = useDispatch();
  const { access_token, user, isLogin } = useSelector(
    (state) => state?.authReducer
  );

  const fetchNotificationsForCount = async () => {
    const url = BaseURL("notifications/all?page=1&limit=5&noCountUpdate=true");
    let response = await Get(url, access_token);

    if (response !== undefined) {
      response?.data?.newNotifications > 0 &&
        dispatch(saveNotiData(response?.data?.newNotifications));
    }
  };

  const handleGetData = async () => {
    const response = await Get(
      BaseURL(`channel/${endpointsUrl(user?.role)}/all?status=active`),
      access_token
    );
    if (response != undefined) {
      dispatch(setAllChannels(response?.data?.data));
    }
  };
  const getData = async () => {
    const response = await Get(
      BaseURL(`gallery/${endpointsUrl(user?.role)}/all`),
      access_token
    );
    if (response) {
      dispatch(setAllVideos(response?.data?.data));
    }
  };

  useEffect(() => {
    access_token && handleGetData();
    access_token && getData();
  }, [access_token]);

  useEffect(() => {
    socket.current = io(apiUrl);
    socket.current.emit("join", user?._id);
    socket?.current?.on("new-notification", (notification, number) => {
      // console.log(notification, "123 123 123");
      // console.log(user?._id, "userData>>>>>>>>>>>>>>>>>>>");
      if (
        notification?.receiver == user?._id &&
        notification?.flag == "video"
      ) {
        // console.log("notification", notification);
        dispatch(saveNotiData(notification));
      }
    });
    return () => {
      socket.current.off("new-notification");
    };
  }, []);

  return (
    <>
      <ToastContainer />

      <BrowserRouter>
        <Suspense fallback={<Loader className={"mvh-100"} />}>
          <Routes>
            <Route
              path="/"
              exact
              // element={<BeforeLoginRoute
              element={
                access_token ? <Navigate replace to="/dashboard" /> : <Login />
              }

              // />}
            />

            <Route
              path="/dashboard"
              exact
              element={<ProtectedRouter element={<Dashboard />} />}
            />
            <Route
              path="/team-member"
              exact
              element={<ProtectedRouter element={<TemaMember />} />}
            />
            <Route
              path="/Channels"
              exact
              element={<ProtectedRouter element={<Channels />} />}
            />
            <Route
              path="/uploaded-videos"
              exact
              element={<ProtectedRouter element={<UploadedVideo />} />}
            />
            <Route
              path="/scheduled-videos"
              exact
              element={<ProtectedRouter element={<ScheduledVideos />} />}
            />
            <Route
              path="/all-videos"
              exact
              element={<ProtectedRouter element={<AllVideos />} />}
            />
            <Route
              path="/VideoDetails/:id"
              exact
              element={<ProtectedRouter element={<VideoDetails />} />}
            />
            <Route
              path="/AddVideoGallery"
              exact
              element={<ProtectedRouter element={<AddVideoGallery />} />}
            />
            <Route
              path="/calendar"
              exact
              element={<ProtectedRouter element={<CalendarPage />} />}
            />

            <Route
              path="/my-profile"
              exact
              element={<ProtectedRouter element={<MyProfile />} />}
            />
            <Route
              path="/upload-video"
              exact
              element={<ProtectedRouter element={<UploadVideo />} />}
            />
            <Route
              path="/privacy-policy-cms"
              exact
              element={<ProtectedRouter element={<PrivacyPolicy />} />}
            />
            <Route
              path="/terms-and-conditions-cms"
              exact
              element={<ProtectedRouter element={<TermsAndCondition />} />}
            />
            <Route
              path="/termsAndCondition"
              exact
              element={<TermsAndConditionView />}
            />
            <Route
              path="/privacyPolicy"
              exact
              element={<BeforeLoginRoute element={<PrivacyPolicyView />} />}
            />
            <Route
              path="/notification"
              exact
              element={<ProtectedRouter element={<NotificationsPage />} />}
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

export default App;
